/* Supp City merkenband: vasthouden = stil, slepen = links/rechts */
(function () {
  function init(w) {
    var t = w.querySelector('.sc-ticker__track');
    if (!t || !t.getAnimations) return;
    var a, sx = 0, st = 0, down = false, moved = false, lw = 1, d = 1, pid = null, timer = null;
    function anim() { a = t.getAnimations()[0]; return a; }
    function wrap(c) { return ((c % d) + d) % d; }
    t.addEventListener('pointerdown', function (e) {
      if (e.button > 0 || !anim()) return;
      clearTimeout(timer);
      down = true; moved = false; sx = e.clientX; pid = e.pointerId;
      a.pause();
      st = a.currentTime || 0;
      d = a.effect.getComputedTiming().duration;
      lw = t.querySelector('.sc-ticker__list').getBoundingClientRect().width || 1;
    });
    t.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        w.classList.add('is-dragging');
        if (e.pointerType === 'mouse') { try { t.setPointerCapture(pid); } catch (_) {} }
      }
      if (moved) a.currentTime = wrap(st - dx / lw * d);
    });
    function end(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false;
      w.classList.remove('is-dragging');
      clearTimeout(timer);
      timer = setTimeout(function () { if (a && !down) a.play(); }, moved ? 1200 : 300);
    }
    t.addEventListener('pointerup', end);
    t.addEventListener('pointercancel', end);
    t.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
    t.addEventListener('contextmenu', function (e) { if (down || moved) e.preventDefault(); });
  }
  function run() { document.querySelectorAll('.sc-ticker').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
